import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { LISTING_STATE_CLOSED } from '../../util/types';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { SQUARE_VARIANTS, FULLSCREEN_VARIANTS, THUMBNAIL_VARIANTS } from './listingImageVariants';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, imageAltBase, onManageDisableScrolling } = props;
  const intl = useIntl();
  const images = listing.images;
  // Mirrors the OrderPanel gating: stock 0 shows "Sold", closed state shows "Closed"
  const isSold = listing.currentStock?.attributes?.quantity === 0;
  const isClosed = listing.attributes?.state === LISTING_STATE_CLOSED;
  const statusOverlayLabel = isSold
    ? intl.formatMessage({ id: 'ListingPage.statusOverlaySold' })
    : isClosed
    ? intl.formatMessage({ id: 'ListingPage.statusOverlayClosed' })
    : null;
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageAltBase={imageAltBase}
        listingId={listing?.id?.uuid}
        imageVariants={SQUARE_VARIANTS}
        fullscreenVariants={FULLSCREEN_VARIANTS}
        thumbnailVariants={THUMBNAIL_VARIANTS}
        statusOverlayLabel={statusOverlayLabel}
        onManageDisableScrolling={onManageDisableScrolling}
      />
    </section>
  );
};

export default SectionGallery;
